import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

export const NotesIcon: FunctionComponent<NotesIconProps> = ({ size = 24, color }) => {
  const { colors } = useTheme()
  const fillColor = color ?? colors.iconDefault
  return (
    <Svg width={size} height={size} viewBox='0 0 24 24' fill='none'>
      <Path
        d='M17.089 3.01807C17.5032 3.01807 17.839 3.35385 17.839 3.76807C17.839 9.10337 19.0422 15.9974 22.5334 20.938C22.6949 21.1668 22.7159 21.4665 22.5871 21.7153C22.4582 21.9641 22.2013 22.1206 21.9211 22.1206H7.63199C7.40518 22.1205 7.19029 22.017 7.04801 21.8403C5.33455 19.7127 4.29473 16.4497 3.64957 13.3677C2.99852 10.2574 2.72561 7.20899 2.61343 5.41943C2.58173 4.91369 2.563 4.50653 2.55191 4.2251C2.54637 4.08441 2.54239 3.97465 2.54019 3.8999C2.53911 3.86297 2.53872 3.83451 2.53824 3.81494C2.538 3.80512 2.53738 3.79674 2.53726 3.7915V3.78369C2.53319 3.58221 2.61009 3.38661 2.75113 3.24268C2.89218 3.09875 3.08575 3.01808 3.28726 3.01807H7.07828V4.51807H4.06949C4.08023 4.74413 4.09108 5.01579 4.11051 5.32568C4.22042 7.0792 4.4869 10.0482 5.11734 13.0601C5.72253 15.9513 6.64464 18.7721 8.00504 20.6206H20.5353C17.548 15.7132 16.4493 9.49573 16.3498 4.51807H14.1603V3.01807H17.089Z'
        fill={fillColor}
      />
      <Path
        d='M2.58069 18.9564V3.87537C2.58069 3.46116 2.91648 3.12537 3.33069 3.12537C3.7449 3.12537 4.08069 3.46115 4.08069 3.87537V18.9564C4.08075 19.764 4.26616 20.1462 4.43811 20.3285C4.60114 20.5013 4.87144 20.6204 5.34924 20.6205H8.09143C8.50543 20.6207 8.84237 20.9564 8.84241 21.3705C8.84226 21.7844 8.50635 22.1203 8.09241 22.1205H5.34924C4.63451 22.1204 3.89538 21.9379 3.34729 21.3568C2.80833 20.7853 2.58075 19.9606 2.58069 18.9564Z'
        fill={fillColor}
      />
      <Path
        d='M7.82794 2.63867V4.89062H13.4109V2.63867H7.82794ZM14.9109 4.89062C14.9109 5.71905 14.2384 6.39062 13.41 6.39062H7.82794C6.99951 6.39062 6.32794 5.71905 6.32794 4.89062V2.63867C6.32794 1.81024 6.99952 1.13867 7.82794 1.13867H13.4109C14.2392 1.13894 14.9109 1.81041 14.9109 2.63867V4.89062Z'
        fill={fillColor}
      />
      <Path
        d='M14.7355 8.27026C15.1497 8.27026 15.4855 8.60605 15.4855 9.02026C15.4855 9.43448 15.1497 9.77026 14.7355 9.77026H6.67694C6.26273 9.77026 5.92694 9.43448 5.92694 9.02026C5.92694 8.60605 6.26273 8.27026 6.67694 8.27026H14.7355Z'
        fill={fillColor}
      />
      <Path
        d='M15.6258 11.8729C16.04 11.8729 16.3758 12.2087 16.3758 12.6229C16.3758 13.0371 16.04 13.3729 15.6258 13.3729H7.5672C7.15299 13.3729 6.8172 13.0371 6.8172 12.6229C6.8172 12.2087 7.15299 11.8729 7.5672 11.8729H15.6258Z'
        fill={fillColor}
      />
      <Path
        d='M16.5245 15.654C16.9387 15.654 17.2745 15.9898 17.2745 16.404C17.2745 16.8182 16.9387 17.154 16.5245 17.154H8.46588C8.05167 17.154 7.71588 16.8182 7.71588 16.404C7.71588 15.9898 8.05167 15.654 8.46588 15.654H16.5245Z'
        fill={fillColor}
      />
    </Svg>
  )
}

type NotesIconProps = {
  size?: number
  color?: string
}
